export enum MatchingStatus {
  MatchingInTheMaking = 'MATCHING_IN_THE_MAKING',
  DailyLimit = 'DAILY_LIMIT',
  Failed = 'FAILED',
  Active = 'ACTIVE',
}
